<!-- IE 2026 10 22 / ODOO-5800 (Igor 22.10: «все графики в форме ячейки … построены на одном компоненте AttrChart, разница только в настройках»): ОБВЯЗКА ГРАФИКА
     ВЕРСІЇ / ПЛАНИ формы ячейки на платформенном AttrChart — синтетический виджет (utils/cellSeriesChart.seriesChart_apply, образец блока запасов cellChart.js):
     контейнер #WIDGET<wid> (attrResize AttrChart меряет его), сам AttrChart, форма легенды CellLegendPop (строка серии — свотч / название / дата / значение в колонке
     под курсором AttrChart.legendHoverIndex, иначе в месяце ячейки; наведение / клик — фокус серии AttrChart.onLegendSeriesHover через cellChartFocusMixin, клик фиксирует),
     подсказка wijmo при открытой легенде выключена (AttrChart.inlineTipOff, правило cellChartTools.tipSuppressed). Собственной SVG-отрисовки нет. Слот — подписи под графиком -->
<template>
    <div :class="['cell-series-chart', 'dropdown-versions-body', 'cell-series-chart-' + kind]" :id="'WIDGET' + wid" @pointerdown.stop @mousedown.stop @pointermove="hover_sync" @pointerleave="hoverI = -1">
        <AttrChart v-if="ready" ref="chart" :widget_id="wid" :attr_id="wid + '-attr'" @vue:mounted="chart_mounted" />
        <slot></slot>
        <CellLegendPop v-if="legendPop && chart" :to="to" cls="cell-series-legend-pop" :offset-top="4" @close="$emit('legend-close')">
            <div v-for="lg in chart.legend" :key="'lg' + lg.kind" :class="['dropdown-legend-row', 'cell-chart-lg', cellChartFocus_cls(kind, lg.kind), cellChartFocus_pinned(kind, lg.kind) ? 'is-pin' : '', lg.current ? 'is-current' : '']"
                 :title="lg.title + (lg.sub ? ' · ' + t('since {date}', { date: lg.sub }) : '') + ' · ' + t('Click to pin the series')"
                 @mouseenter="chartFocus_hover(kind, lg.kind)" @mouseleave="chartFocus_leave(kind)" @click.stop="chartFocus_click(kind, lg.kind)">
                <svg width="26" height="10" class="dropdown-versions-lgi">
                    <rect v-if="lg.bar" x="1" y="1" width="24" height="8" :fill="lg.color" :stroke="lg.hatch || null" :stroke-width="lg.hatch ? 1 : null"/>
                    <line v-else x1="1" y1="5" x2="25" y2="5" :stroke="lg.color" :stroke-width="lg.width" :stroke-dasharray="lg.dash || null" stroke-linecap="round"/>
                </svg>
                <span class="cell-chart-lg-title">{{ lg.title }}</span><span class="dropdown-versions-since" v-if="lg.sub"> · {{ lg.sub }}</span><span class="cell-chart-lg-val">{{ legendValue(lg) }}</span>
            </div>
            <div class="dropdown-legend-hint">{{ hoverDate ? t('Values at {date}', { date: hoverDate }) : t('Values in the cell month {month}', { month: chart.center }) }}</div>
            <div class="dropdown-legend-hint dropdown-versions-rule" v-for="(h, hi) in chart.hints" :key="'h' + hi" :title="h">{{ h }}</div>
        </CellLegendPop>
    </div>
</template>

<script>
import { t } from '@/i18n'
import { seriesChart_apply, seriesChart_legendValue } from '@/utils/cellSeriesChart'
import { cellChartFocusMixin } from '@/utils/cellChartTools'
import CellLegendPop from '@/components/widgets/CellLegendPop.vue'

export default {
    name: 'CellSeriesChart',
    components: { CellLegendPop },   // AttrChart — глобальный компонент (main.js)
    mixins: [cellChartFocusMixin],
    props: {
        chart: { type: Object, default: null },        // utils/cellSeriesChart.versionsChart_build / plansChart_build
        wid: { type: String, required: true },         // id синтетического виджета (store.WIDGETS)
        kind: { type: String, default: 'versions' },   // вид для состояния фокуса (cellChartFocusMixin) и класса контейнера
        store: { type: Object, default: null },
        legendPop: { type: Boolean, default: false },  // форма легенды открыта (кнопка 🏷 родителя)
        to: { type: [String, Object], default: null }, // куда телепортировать форму легенды (Full screen)
    },
    emits: ['legend-close'],
    data() { return { ready: false, hoverI: -1 } },
    computed: {
        hoverDate() { const r = this.chart && this.hoverI >= 0 ? (this.chart.rows || [])[this.hoverI] : null; return r ? r.date : '' },
    },
    watch: {
        chart: { handler() { this.sync() }, immediate: true },
        legendPop() { this.tipSync() },   // легенда открыта — подсказки wijmo нет (inlineTipOff)
    },
    methods: {
        t(k, p) { return t(k, p) },
        vue() { const r = this.$refs.chart; return Array.isArray(r) ? r[0] : r },
        sync() {
            this.hoverI = -1; this.chartFocus_clear(this.kind)
            if (!this.chart || !this.store) { this.ready = false; return }
            try {
                seriesChart_apply(this.store, this.wid, this.chart)
                if (!this.ready) this.ready = true
                else { const v = this.vue(); if (v && typeof v.content_Changed === 'function') v.content_Changed(); this.tipSync() }
            } catch (e) { console.warn('cell series chart sync failed', e); this.ready = false }
        },
        chart_mounted() { this.$nextTick(() => this.tipSync()) },
        tipSync() { try { const v = this.vue(); if (v && 'inlineTipOff' in v) v.inlineTipOff = this.tipSuppressed(this.kind) } catch (e) { /* чарт ещё не создан */ } },
        chartFocus_changed(kind, key) {   // фокус серии — подсветкой AttrChart (своя серия ярче, остальные приглушены), как у блока STOCK
            try { const v = this.vue(); if (v && typeof v.onLegendSeriesHover === 'function') v.onLegendSeriesHover(key == null ? null : String(key)) } catch (e) { /* чарт ещё не создан */ }
        },
        hover_sync() { try { const v = this.vue(); const i = v ? v.legendHoverIndex : null; this.hoverI = (i === null || i === undefined) ? -1 : Number(i) } catch (e) { this.hoverI = -1 } },
        legendValue(lg) { return seriesChart_legendValue(this.chart, lg, this.hoverI) },
    },
}
</script>

<style>
/* IE 2026 10 22 / ODOO-5800: график ВЕРСІЇ / ПЛАНИ на AttrChart — без своих кнопок чарта (островок — CellChartTools родителя); строки формы легенды — стили .cell-chart-lg Dropdown.vue */
.cell-series-chart { position: relative; padding: 2px 6px 4px 8px; }
.cell-series-chart .corner-island { display: none; }
.cell-series-legend-pop .dropdown-legend-row { display: flex; align-items: center; gap: 4px; }
.cell-series-legend-pop .dropdown-legend-row.is-current { font-weight: 600; }
</style>
